import { css } from "@compiled/react";
import { defineMessages } from "react-intl";

import { media } from "@atlaskit/primitives";
import FeatureGates from "@atlassian/feature-gate-js-client";

import { GlobalFooter } from "@/patterns/global-footer/src";

import {
    AtlassianAccess,
    DataCenter,
    PROMOTE_ADDONS_ON_PRICING_PAGES_EXPERIMENT,
    PROMOTE_ADDONS_ON_PRICING_PAGES_VARIANT
} from "../../../components/wpl/pricing/src";
import { ConfluencePricingPageProps } from "../../../pages/software/confluence/pricing/confluence-pricing-page";
import QuestionsCta from "../../../patterns/wpl/questions-cta/src";
import ConfluenceSoftwareNav from "../../confluence-software-page/src/sections/confluence-navbar";

import CloudFeaturesTables from "./sections/cloud-features";
import { ConfluenceAddons } from "./sections/confluence-addons.tsx";
import ConfluencePriceFinderTeam24 from "./sections/confluence-price-finder-team24";
import { DataCenterCalculator } from "./sections/data-center-calculator";
import { CloudPricingFaq } from "./sections/pricing-faq";

const dataCenterSection = css({
    margin: "1rem",
    [media.above.sm]: {
        margin: "2.5rem auto",
        maxWidth: "56.875rem"
    }
});

export const ConfluencePricingPageTemplate = (
    props: ConfluencePricingPageProps
) => {
    const messages = defineMessages({
        ctaText: {
            id: "ConfluencePricingPage.ctaText",
            defaultMessage:
                "We have answers. Read our full list of common questions and answers for <generalCta>general cloud pricing and licensing</generalCta> or specific <specificCta>Confluence pricing and licensing</specificCta>."
        }
    });

    const promoteAddonsExperiment: string = FeatureGates.getExperimentValue(
        PROMOTE_ADDONS_ON_PRICING_PAGES_EXPERIMENT,
        "cohort",
        "control",
        {
            fireExperimentExposure: true
        }
    );
    const showAddonsExperimentTreatment =
        promoteAddonsExperiment === PROMOTE_ADDONS_ON_PRICING_PAGES_VARIANT;

    return (
        <div>
            <ConfluenceSoftwareNav />

            <div>
                <ConfluencePriceFinderTeam24
                    pricing={props.pricing}
                    countryCode={props.countryCode}
                />
                <section css={dataCenterSection}>
                    <DataCenter>
                        <div css={css({ marginInlineStart: "-28px" })}>
                            <DataCenterCalculator
                                serverSidePricing={
                                    props.pricing?.localizedPriceBlockDropdown
                                        ?.confluence
                                }
                                countryCode={props.countryCode}
                            />
                        </div>
                    </DataCenter>
                </section>
                {showAddonsExperimentTreatment && <ConfluenceAddons />}
                <CloudFeaturesTables />
                <AtlassianAccess />
                <CloudPricingFaq />
                <QuestionsCta
                    ctaText={messages.ctaText}
                    specificCtaLink="/licensing/confluence"
                    generalCtaLink="/licensing/cloud"
                />
            </div>

            <GlobalFooter />
        </div>
    );
};
